"use client";

import { c as _c } from "react/compiler-runtime";
import OverviewTab from "@/app/[tenant]/(console)/patient/(patient-page)/[id]/tabs/overview-tab";
import { Button, Drawer, DrawerContent, DrawerFooter, DrawerHeader, DrawerTitle } from "@/components/ui";
import { DialogBody } from "@/components/ui/dialog";
import { OverviewLayoutProvider } from "@/contexts/overview-layout-context";
import { formatDoseComponentAmount, getDoseComponentName, getDoseComponents } from "@/lib/dose-components";
import { formatName } from "@/lib/format-data";
import { MedicationSummary } from "@/types/medication";
import { PatientDetail } from "@/types/patient";
interface SignOffDoseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  medication: MedicationSummary | null;
  patient: PatientDetail;
  isLoading?: boolean;
}
export default function SignOffDoseModal(t0) {
  const $ = _c(27);
  const {
    isOpen,
    onClose,
    onConfirm,
    medication,
    patient,
    isLoading
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = open => !open && onClose();
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <DrawerTitle>Are you sure you want to sign off on this dose?</DrawerTitle>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== medication || $[4] !== patient) {
    t3 = medication && <div className="space-y-1 text-body text-foreground-secondary"><p>Dose event for {formatName(patient.firstName, patient.lastName)}</p><ul className="list-disc space-y-0.5 pl-5">{getDoseComponents(medication).map(_temp)}</ul></div>;
    $[3] = medication;
    $[4] = patient;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <DrawerHeader>{t2}{t3}</DrawerHeader>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== patient) {
    t5 = <DialogBody className="p-0"><OverviewLayoutProvider><OverviewTab patient={patient} /></OverviewLayoutProvider></DialogBody>;
    $[8] = patient;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isLoading || $[11] !== onClose) {
    t6 = <Button variant="secondary" onClick={onClose} disabled={isLoading}>Cancel</Button>;
    $[10] = isLoading;
    $[11] = onClose;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isLoading || $[14] !== onConfirm) {
    t7 = <Button variant="primary" onClick={onConfirm} isLoading={isLoading}>Confirm sign off</Button>;
    $[13] = isLoading;
    $[14] = onConfirm;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <DrawerFooter>{t6}{t7}</DrawerFooter>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t8) {
    t9 = <DrawerContent className="sm:max-w-xl">{t4}{t5}{t8}</DrawerContent>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== isOpen || $[24] !== t1 || $[25] !== t9) {
    t10 = <Drawer open={isOpen} onOpenChange={t1}>{t9}</Drawer>;
    $[23] = isOpen;
    $[24] = t1;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
}
function _temp(component, index) {
  return <li key={component.id ?? `${component.name}-${index}`}>{formatDoseComponentAmount(component)} of{" "}{getDoseComponentName(component)}</li>;
}